module.exports = __webpack_public_path__ + "img/ico-template-alt.ec56b0a1.svg";